var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "document-card", class: _vm.documentClasses },
    [
      _c(
        "div",
        { staticClass: "document-card__topic" },
        [
          _vm.localAccepted ||
          (_vm.localFilled && !_vm.localAccepted) ||
          _vm.localNotRequired
            ? [
                _c("h3", { staticClass: "document-card__title" }, [
                  _vm.alreadyAddedDocuments && _vm.alreadyAddedDocuments.length
                    ? _c(
                        "span",
                        { staticClass: "mr-1" },
                        [
                          _c("theme-checkboxes", {
                            attrs: { name: "check_all" },
                            on: { changed: _vm.toggleAllFiles }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v("\n        " + _vm._s(_vm.title) + "\n        "),
                  _vm.localAccepted
                    ? _c("i", {
                        staticClass:
                          "icon-check ml-auto text-[#77b866] text-[15px]"
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.localAccepted
                    ? _c(
                        "span",
                        {
                          staticClass:
                            "text-[#77b866] text-[14px] font-bold hidden md:inline"
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.locales &&
                                _vm.locales.common &&
                                _vm.locales.common.approved
                            )
                          )
                        ]
                      )
                    : _vm._e()
                ])
              ]
            : _vm._e(),
          _vm._v(" "),
          !_vm.localAccepted && !_vm.localFilled && !_vm.localNotRequired
            ? [
                _c("h3", { staticClass: "document-card__title" }, [
                  _vm._v("\n        " + _vm._s(_vm.title) + "\n        "),
                  _vm.showReason
                    ? _c("i", {
                        staticClass:
                          "icon-warning ml-auto text-[#FF695B] text-[20px]"
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.showReason
                    ? _c(
                        "span",
                        {
                          staticClass:
                            "text-[#FF695B] text-[14px] font-bold hidden md:inline"
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.locales &&
                                _vm.locales.common &&
                                _vm.locales.common.issue_with_document
                            )
                          )
                        ]
                      )
                    : _vm._e()
                ])
              ]
            : _vm._e()
        ],
        2
      ),
      _vm._v(" "),
      _c("div", { staticClass: "document-card__inner" }, [
        _vm.localAccepted
          ? _c("strong", { staticClass: "document-card__subheading" }, [
              _vm._v(_vm._s(_vm.subtitle))
            ])
          : _vm._e(),
        _vm._v(" "),
        !_vm.localAccepted && !_vm.localFilled
          ? _c("span", { staticClass: "document-card__subheading" }, [
              _vm._v("\n      " + _vm._s(_vm.notificationPrefix) + "\n      "),
              _c("strong", [
                _vm.localTypeMonths
                  ? _c("span", [_vm._v(_vm._s(_vm.numberOfDocuments))])
                  : _vm._e(),
                _vm._v("\n        " + _vm._s(_vm.notification) + "\n      ")
              ])
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.localFilled && !_vm.localAccepted
          ? _c("strong", { staticClass: "document-card__subheading" }, [
              _vm._v(_vm._s(_vm.cardFilledNotification))
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.localTypeDefault
          ? _c("div", { staticClass: "document-card__block" }, [
              _vm.alreadyAddedDocuments && _vm.alreadyAddedDocuments.length
                ? _c("div", { staticClass: "document-card__row" }, [
                    _c(
                      "ol",
                      { staticClass: "document-card__image-list" },
                      _vm._l(_vm.alreadyAddedDocuments, function(
                        documentFile,
                        index
                      ) {
                        var _obj
                        return _c(
                          "li",
                          [
                            _c("theme-checkboxes", {
                              attrs: {
                                setForm: true,
                                form: "removeForm",
                                name: "remove[]",
                                options:
                                  ((_obj = {}),
                                  (_obj[documentFile.id] =
                                    documentFile.imageName),
                                  _obj)
                              },
                              on: { changed: _vm.emitChange }
                            }),
                            _vm._v(" "),
                            !documentFile.disable_remove && !_vm.disableRemove
                              ? _c(
                                  "span",
                                  {
                                    staticClass:
                                      "document-card__delete-document",
                                    on: {
                                      click: function($event) {
                                        return _vm.deleteAddedDocument(
                                          documentFile.id,
                                          index
                                        )
                                      }
                                    }
                                  },
                                  [
                                    _c("i", { staticClass: "icon-delete" }),
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(
                                          _vm.locales &&
                                            _vm.locales.documents &&
                                            _vm.locales.documents
                                              .delete_document
                                        ) +
                                        "\n            "
                                    )
                                  ]
                                )
                              : _vm._e()
                          ],
                          1
                        )
                      }),
                      0
                    )
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c("div", { staticClass: "document-card__row" }, [
                _c(
                  "ul",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: !_vm.checkboxState,
                        expression: "!checkboxState"
                      }
                    ],
                    staticClass: "document-card__image-list js-inputs-parent"
                  },
                  _vm._l(_vm.inputsTypeFile, function(input, index) {
                    return _c(
                      "li",
                      [
                        _c("theme-file", {
                          attrs: {
                            inputClass: "document-card__input-file",
                            accept: "application/pdf, image/*",
                            name:
                              "file[" + _vm.tenantId + "][" + _vm.id + "][]",
                            id: _vm.inputFileId + "-" + index
                          },
                          on: {
                            change: function($event) {
                              return _vm.fileInputChanged($event, index)
                            }
                          }
                        })
                      ],
                      1
                    )
                  }),
                  0
                ),
                _vm._v(" "),
                _c("div", { staticClass: "document-card__image-list-bottom" }, [
                  _c(
                    "button",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: !_vm.checkboxState,
                          expression: "!checkboxState"
                        }
                      ],
                      staticClass:
                        "theme-btn theme-btn--small theme-btn--tertiary",
                      attrs: { type: "button" },
                      on: { click: _vm.addInputTypeFile }
                    },
                    [
                      _c("i", { staticClass: "icon-plus" }),
                      _vm._v(
                        "\n            " +
                          _vm._s(
                            _vm.locales.common &&
                              _vm.locales.common.new_document
                          ) +
                          "\n          "
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _vm.showReason
                    ? _c(
                        "div",
                        { staticClass: "document-card__flag-checkbox-holder" },
                        [
                          _c("input", {
                            attrs: {
                              type: "hidden",
                              value: "",
                              name:
                                "reason[" + _vm.tenantId + "][" + _vm.id + "]"
                            }
                          }),
                          _vm._v(" "),
                          _c(
                            "label",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: !_vm.isDocumentsAdded,
                                  expression: "!isDocumentsAdded"
                                }
                              ],
                              staticClass: "document-card__flag-checkbox-label",
                              attrs: { for: _vm.inputCheckboxId }
                            },
                            [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.checkboxState,
                                    expression: "checkboxState"
                                  }
                                ],
                                staticClass: "document-card__flag-checkbox",
                                attrs: {
                                  type: "checkbox",
                                  name: _vm.inputCheckboxId,
                                  id: _vm.inputCheckboxId,
                                  disabled: _vm.isDocumentsAdded
                                },
                                domProps: {
                                  checked: Array.isArray(_vm.checkboxState)
                                    ? _vm._i(_vm.checkboxState, null) > -1
                                    : _vm.checkboxState
                                },
                                on: {
                                  change: [
                                    function($event) {
                                      var $$a = _vm.checkboxState,
                                        $$el = $event.target,
                                        $$c = $$el.checked ? true : false
                                      if (Array.isArray($$a)) {
                                        var $$v = null,
                                          $$i = _vm._i($$a, $$v)
                                        if ($$el.checked) {
                                          $$i < 0 &&
                                            (_vm.checkboxState = $$a.concat([
                                              $$v
                                            ]))
                                        } else {
                                          $$i > -1 &&
                                            (_vm.checkboxState = $$a
                                              .slice(0, $$i)
                                              .concat($$a.slice($$i + 1)))
                                        }
                                      } else {
                                        _vm.checkboxState = $$c
                                      }
                                    },
                                    _vm.cardChanged
                                  ]
                                }
                              }),
                              _vm._v(" "),
                              _c("i", {
                                staticClass: "document-card__flag-checkbox-icon"
                              }),
                              _vm._v(" "),
                              _c("span", [_vm._v(_vm._s(_vm.checkboxText))])
                            ]
                          )
                        ]
                      )
                    : _vm._e()
                ])
              ]),
              _vm._v(" "),
              _vm.checkboxState
                ? _c("div", { staticClass: "document-card__row" }, [
                    _c("textarea", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.localTextareaData,
                          expression: "localTextareaData"
                        }
                      ],
                      staticClass: "document-card__textarea",
                      attrs: {
                        id: _vm.textareaId,
                        name: "reason[" + _vm.tenantId + "][" + _vm.id + "]",
                        placeholder: _vm.textareaPlaceholder
                      },
                      domProps: { value: _vm.localTextareaData },
                      on: {
                        keyup: _vm.cardChanged,
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.localTextareaData = $event.target.value
                        }
                      }
                    })
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c("div", { staticClass: "document-card__buttons-group" }, [
                _c("input", {
                  class: [
                    "theme-btn theme-btn--small theme-btn--primary",
                    !_vm.localFilled && "theme-btn--primary-disabled",
                    _vm.loading && "theme-btn--primary-disabled"
                  ],
                  attrs: {
                    type: "submit",
                    name: "submit",
                    disabled: !_vm.localFilled
                  },
                  domProps: { value: _vm.buttonValue },
                  on: {
                    click: function($event) {
                      _vm.loading = true
                    }
                  }
                }),
                _vm._v(" "),
                _vm.showEdrButton
                  ? _c(
                      "button",
                      {
                        staticClass:
                          "theme-btn theme-btn--small theme-btn--theme",
                        attrs: {
                          type: "submit",
                          formaction: _vm.edrAction,
                          form: "edr"
                        },
                        on: {
                          click: function($event) {
                            $event.preventDefault()
                            return _vm.requestEdrLink.apply(null, arguments)
                          }
                        }
                      },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              _vm.locales.users &&
                                _vm.locales.users.request_edr_link
                            ) +
                            "\n        "
                        )
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.showGuaranteeButton
                  ? _c(
                      "button",
                      {
                        staticClass:
                          "theme-btn theme-btn--small theme-btn--theme",
                        attrs: {
                          type: "submit",
                          formaction: _vm.guaranteeAction,
                          form: "guarantee"
                        },
                        on: {
                          click: function($event) {
                            $event.preventDefault()
                            return _vm.requestGuarantee.apply(null, arguments)
                          }
                        }
                      },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              _vm.locales.documents &&
                                _vm.locales.documents.request_guarantee
                            ) +
                            "\n        "
                        )
                      ]
                    )
                  : _vm._e()
              ])
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.localTypeMonths
          ? _c(
              "div",
              { staticClass: "document-card__block" },
              [
                _vm._l(_vm.localMonths, function(month, parentIndex) {
                  return _c(
                    "div",
                    {
                      staticClass:
                        "document-card__row document-card__row--border"
                    },
                    [
                      _c("div", { staticClass: "document-card__row-title" }, [
                        _vm._v(_vm._s(month.date))
                      ]),
                      _vm._v(" "),
                      month.documents && month.documents.length
                        ? _c("div", { staticClass: "document-card__row" }, [
                            _c(
                              "ol",
                              { staticClass: "document-card__image-list" },
                              _vm._l(month.documents, function(
                                documentFile,
                                index
                              ) {
                                return _c("li", [
                                  _c(
                                    "span",
                                    {
                                      staticClass: "document-card__image-name"
                                    },
                                    [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(documentFile.imageName) +
                                          "\n              "
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  !documentFile.disable_remove &&
                                  !_vm.disableRemove
                                    ? _c(
                                        "span",
                                        {
                                          staticClass:
                                            "document-card__delete-document",
                                          on: {
                                            click: function($event) {
                                              return _vm.deleteAddedDocument(
                                                documentFile.id,
                                                parentIndex,
                                                index
                                              )
                                            }
                                          }
                                        },
                                        [
                                          _c("i", {
                                            staticClass: "icon-delete"
                                          }),
                                          _vm._v(
                                            "\n                " +
                                              _vm._s(
                                                _vm.locales &&
                                                  _vm.locales.documents &&
                                                  _vm.locales.documents
                                                    .delete_document
                                              ) +
                                              "\n              "
                                          )
                                        ]
                                      )
                                    : _vm._e()
                                ])
                              }),
                              0
                            )
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _c("div", { staticClass: "document-card__row" }, [
                        _c(
                          "ul",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: !month.checkboxValue,
                                expression: "!month.checkboxValue"
                              }
                            ],
                            staticClass:
                              "document-card__image-list js-inputs-parent"
                          },
                          _vm._l(
                            _vm.monthsInputsTypeFile[parentIndex],
                            function(input, index) {
                              return _c(
                                "li",
                                [
                                  _c("theme-file", {
                                    attrs: {
                                      inputClass: "document-card__input-file",
                                      accept: "application/pdf, image/*",
                                      name:
                                        "month_file[" +
                                        _vm.tenantId +
                                        "][" +
                                        _vm.id +
                                        "][" +
                                        month.index +
                                        "][]",
                                      id:
                                        _vm.inputFileId +
                                        "-" +
                                        month.id +
                                        "-" +
                                        index
                                    },
                                    on: {
                                      change: function($event) {
                                        return _vm.fileInputChanged(
                                          $event,
                                          parentIndex
                                        )
                                      }
                                    }
                                  })
                                ],
                                1
                              )
                            }
                          ),
                          0
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "document-card__image-list-bottom" },
                          [
                            _c(
                              "button",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: !month.checkboxValue,
                                    expression: "!month.checkboxValue"
                                  }
                                ],
                                staticClass:
                                  "theme-btn theme-btn--small theme-btn--tertiary",
                                attrs: { type: "button" },
                                on: {
                                  click: function($event) {
                                    return _vm.addInputTypeFile(parentIndex)
                                  }
                                }
                              },
                              [
                                _c("i", { staticClass: "icon-plus" }),
                                _vm._v(
                                  "\n              " +
                                    _vm._s(
                                      _vm.locales.common &&
                                        _vm.locales.common.new_document
                                    ) +
                                    "\n            "
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _vm.showReason
                              ? _c(
                                  "div",
                                  {
                                    staticClass:
                                      "document-card__flag-checkbox-holder"
                                  },
                                  [
                                    _c("input", {
                                      attrs: {
                                        type: "hidden",
                                        value: "",
                                        name:
                                          "month_reason[" +
                                          _vm.tenantId +
                                          "][" +
                                          _vm.id +
                                          "][" +
                                          month.index +
                                          "]"
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "label",
                                      {
                                        directives: [
                                          {
                                            name: "show",
                                            rawName: "v-show",
                                            value: !month.documents.length,
                                            expression:
                                              "!month.documents.length"
                                          }
                                        ],
                                        staticClass:
                                          "document-card__flag-checkbox-label",
                                        attrs: {
                                          for:
                                            _vm.inputCheckboxId +
                                            "-" +
                                            parentIndex
                                        }
                                      },
                                      [
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: month.checkboxValue,
                                              expression: "month.checkboxValue"
                                            }
                                          ],
                                          staticClass:
                                            "document-card__flag-checkbox",
                                          attrs: {
                                            type: "checkbox",
                                            name:
                                              _vm.inputCheckboxId +
                                              "-" +
                                              parentIndex,
                                            id:
                                              _vm.inputCheckboxId +
                                              "-" +
                                              parentIndex,
                                            disabled: !!month.documents.length
                                          },
                                          domProps: {
                                            checked: Array.isArray(
                                              month.checkboxValue
                                            )
                                              ? _vm._i(
                                                  month.checkboxValue,
                                                  null
                                                ) > -1
                                              : month.checkboxValue
                                          },
                                          on: {
                                            change: [
                                              function($event) {
                                                var $$a = month.checkboxValue,
                                                  $$el = $event.target,
                                                  $$c = $$el.checked
                                                    ? true
                                                    : false
                                                if (Array.isArray($$a)) {
                                                  var $$v = null,
                                                    $$i = _vm._i($$a, $$v)
                                                  if ($$el.checked) {
                                                    $$i < 0 &&
                                                      _vm.$set(
                                                        month,
                                                        "checkboxValue",
                                                        $$a.concat([$$v])
                                                      )
                                                  } else {
                                                    $$i > -1 &&
                                                      _vm.$set(
                                                        month,
                                                        "checkboxValue",
                                                        $$a
                                                          .slice(0, $$i)
                                                          .concat(
                                                            $$a.slice($$i + 1)
                                                          )
                                                      )
                                                  }
                                                } else {
                                                  _vm.$set(
                                                    month,
                                                    "checkboxValue",
                                                    $$c
                                                  )
                                                }
                                              },
                                              _vm.cardChanged
                                            ]
                                          }
                                        }),
                                        _vm._v(" "),
                                        _c("i", {
                                          staticClass:
                                            "document-card__flag-checkbox-icon"
                                        }),
                                        _vm._v(" "),
                                        _c("span", [
                                          _vm._v(_vm._s(_vm.checkboxText))
                                        ])
                                      ]
                                    )
                                  ]
                                )
                              : _vm._e()
                          ]
                        )
                      ]),
                      _vm._v(" "),
                      month.checkboxValue
                        ? _c("div", { staticClass: "document-card__row" }, [
                            _c("textarea", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: month.textareaData,
                                  expression: "month.textareaData"
                                }
                              ],
                              staticClass: "document-card__textarea",
                              attrs: {
                                id: _vm.textareaId + "-" + parentIndex,
                                name:
                                  "month_reason[" +
                                  _vm.tenantId +
                                  "][" +
                                  _vm.id +
                                  "][" +
                                  month.index +
                                  "]",
                                placeholder: _vm.textareaPlaceholder
                              },
                              domProps: { value: month.textareaData },
                              on: {
                                keyup: _vm.cardChanged,
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.$set(
                                    month,
                                    "textareaData",
                                    $event.target.value
                                  )
                                }
                              }
                            })
                          ])
                        : _vm._e()
                    ]
                  )
                }),
                _vm._v(" "),
                _vm.showReason
                  ? _c("input", {
                      class: [
                        "theme-btn theme-btn--small theme-btn--primary",
                        !_vm.localFilled && "theme-btn--primary-disabled",
                        _vm.loading && "theme-btn--primary-disabled"
                      ],
                      attrs: {
                        type: "submit",
                        name: "submit",
                        disabled: !_vm.localFilled
                      },
                      domProps: { value: _vm.buttonValue },
                      on: {
                        click: function($event) {
                          _vm.loading = true
                        }
                      }
                    })
                  : _vm._e()
              ],
              2
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.localTypeAlternate
          ? _c("div", { staticClass: "document-card__block" }, [
              _vm.alreadyAddedDocuments && _vm.alreadyAddedDocuments.length
                ? _c(
                    "div",
                    {
                      staticClass:
                        "document-card__row document-card__row--border"
                    },
                    [
                      _c(
                        "ol",
                        { staticClass: "document-card__image-list" },
                        _vm._l(_vm.alreadyAddedDocuments, function(
                          documentFile,
                          index
                        ) {
                          return _c("li", [
                            _c(
                              "span",
                              { staticClass: "document-card__image-name" },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(documentFile.imageName) +
                                    "\n            "
                                )
                              ]
                            ),
                            _vm._v(" "),
                            !documentFile.disable_remove && !_vm.disableRemove
                              ? _c(
                                  "span",
                                  {
                                    staticClass:
                                      "document-card__delete-document",
                                    on: {
                                      click: function($event) {
                                        return _vm.deleteAddedDocument(
                                          documentFile.id,
                                          index
                                        )
                                      }
                                    }
                                  },
                                  [
                                    _c("i", { staticClass: "icon-delete" }),
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(
                                          _vm.locales &&
                                            _vm.locales.documents &&
                                            _vm.locales.documents
                                              .delete_document
                                        ) +
                                        "\n            "
                                    )
                                  ]
                                )
                              : _vm._e()
                          ])
                        }),
                        0
                      )
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "document-card__row document-card__row--border"
                },
                [
                  _c(
                    "ul",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: !_vm.checkboxState,
                          expression: "!checkboxState"
                        }
                      ],
                      staticClass: "document-card__image-list js-inputs-parent"
                    },
                    _vm._l(_vm.inputsTypeFile, function(input, index) {
                      return _c(
                        "li",
                        [
                          _c("theme-file", {
                            attrs: {
                              inputClass: "document-card__input-file",
                              accept: "application/pdf, image/*",
                              name:
                                "file[" + _vm.tenantId + "][" + _vm.id + "][]",
                              id: _vm.inputFileId + "-" + index
                            },
                            on: { change: _vm.fileInputChanged }
                          })
                        ],
                        1
                      )
                    }),
                    0
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "document-card__image-list-bottom" },
                    [
                      _c(
                        "button",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: !_vm.checkboxState,
                              expression: "!checkboxState"
                            }
                          ],
                          staticClass:
                            "theme-btn theme-btn--small theme-btn--tertiary",
                          attrs: { type: "button" },
                          on: { click: _vm.addInputTypeFile }
                        },
                        [
                          _c("i", { staticClass: "icon-plus" }),
                          _vm._v(
                            "\n            " +
                              _vm._s(
                                _vm.locales.common &&
                                  _vm.locales.common.new_document
                              ) +
                              "\n          "
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _vm.showReason
                        ? _c(
                            "div",
                            {
                              staticClass: "document-card__flag-checkbox-holder"
                            },
                            [
                              _c("input", {
                                attrs: {
                                  type: "hidden",
                                  value: "",
                                  name:
                                    "reason[" +
                                    _vm.tenantId +
                                    "][" +
                                    _vm.id +
                                    "]"
                                }
                              }),
                              _vm._v(" "),
                              _c(
                                "label",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value:
                                        !_vm.isDocumentsAdded ||
                                        !_vm.isAlternateFormFilled,
                                      expression:
                                        "!isDocumentsAdded || !isAlternateFormFilled"
                                    }
                                  ],
                                  staticClass:
                                    "document-card__flag-checkbox-label",
                                  attrs: { for: _vm.inputCheckboxId }
                                },
                                [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.checkboxState,
                                        expression: "checkboxState"
                                      }
                                    ],
                                    staticClass: "document-card__flag-checkbox",
                                    attrs: {
                                      type: "checkbox",
                                      name: _vm.inputCheckboxId,
                                      id: _vm.inputCheckboxId,
                                      disabled:
                                        _vm.isDocumentsAdded ||
                                        _vm.isAlternateFormFilled
                                    },
                                    domProps: {
                                      checked: Array.isArray(_vm.checkboxState)
                                        ? _vm._i(_vm.checkboxState, null) > -1
                                        : _vm.checkboxState
                                    },
                                    on: {
                                      change: [
                                        function($event) {
                                          var $$a = _vm.checkboxState,
                                            $$el = $event.target,
                                            $$c = $$el.checked ? true : false
                                          if (Array.isArray($$a)) {
                                            var $$v = null,
                                              $$i = _vm._i($$a, $$v)
                                            if ($$el.checked) {
                                              $$i < 0 &&
                                                (_vm.checkboxState = $$a.concat(
                                                  [$$v]
                                                ))
                                            } else {
                                              $$i > -1 &&
                                                (_vm.checkboxState = $$a
                                                  .slice(0, $$i)
                                                  .concat($$a.slice($$i + 1)))
                                            }
                                          } else {
                                            _vm.checkboxState = $$c
                                          }
                                        },
                                        _vm.cardChanged
                                      ]
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("i", {
                                    staticClass:
                                      "document-card__flag-checkbox-icon"
                                  }),
                                  _vm._v(" "),
                                  _c("span", [_vm._v(_vm._s(_vm.checkboxText))])
                                ]
                              )
                            ]
                          )
                        : _vm._e()
                    ]
                  ),
                  _vm._v(" "),
                  _vm.checkboxState
                    ? _c("div", { staticClass: "document-card__row" }, [
                        _c("textarea", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.localTextareaData,
                              expression: "localTextareaData"
                            }
                          ],
                          staticClass: "document-card__textarea",
                          attrs: {
                            id: _vm.textareaId,
                            name:
                              "reason[" + _vm.tenantId + "][" + _vm.id + "]",
                            placeholder: _vm.textareaPlaceholder
                          },
                          domProps: { value: _vm.localTextareaData },
                          on: {
                            keyup: _vm.cardChanged,
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.localTextareaData = $event.target.value
                            }
                          }
                        })
                      ])
                    : _vm._e()
                ]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "document-card__row" }, [
                _c("div", { staticClass: "document-card__form-title" }, [
                  _vm._v(_vm._s(_vm.localSmallFormDescription))
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "document-card__form" },
                  _vm._l(_vm.localSmallForm, function(row) {
                    return _c(
                      "div",
                      { staticClass: "document-card__form-box" },
                      [
                        _c(
                          "label",
                          {
                            staticClass: "document-card__textfield-label",
                            attrs: { for: _vm.textFieldId + "-" + row.id }
                          },
                          [
                            _vm._v(
                              "\n              " +
                                _vm._s(row.labelText) +
                                "\n            "
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: row.inputData,
                              expression: "row.inputData"
                            }
                          ],
                          staticClass: "document-card__textfield",
                          attrs: {
                            type: "text",
                            name: row.fieldName,
                            id: _vm.textFieldId + "-" + row.id
                          },
                          domProps: { value: row.inputData },
                          on: {
                            keyup: _vm.cardChanged,
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(row, "inputData", $event.target.value)
                            }
                          }
                        })
                      ]
                    )
                  }),
                  0
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "document-card__buttons-group" }, [
                _vm.showReason
                  ? _c("input", {
                      class: [
                        "theme-btn theme-btn--small theme-btn--primary",
                        !_vm.localFilled && "theme-btn--primary-disabled",
                        _vm.loading && "theme-btn--primary-disabled"
                      ],
                      attrs: {
                        type: "submit",
                        name: "submit",
                        disabled: !_vm.localFilled
                      },
                      domProps: { value: _vm.buttonValue },
                      on: {
                        click: function($event) {
                          _vm.loading = true
                        }
                      }
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.showSurveyButton
                  ? _c(
                      "button",
                      {
                        class: [
                          "theme-btn theme-btn--small theme-btn--theme",
                          _vm.disabled && "theme-btn--theme-disabled"
                        ],
                        attrs: {
                          type: "submit",
                          disabled: _vm.disabled,
                          formaction: _vm.surveyAction,
                          form: "edr"
                        },
                        on: {
                          click: function($event) {
                            $event.preventDefault()
                            return _vm.sendSurvey.apply(null, arguments)
                          }
                        }
                      },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(
                              _vm.locales.documents &&
                                _vm.locales.documents
                                  .send_good_tenant_survey_to_landlord
                            ) +
                            "\n        "
                        )
                      ]
                    )
                  : _vm._e()
              ])
            ])
          : _vm._e()
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-ed69dcf4", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ed69dcf4","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/VDocumentCard.vue
// module id = 350
// module chunks = 1 2